import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button, Flex } from '@resideo/blueprint-react';

import ModalHeader from 'components/common/ModalHeader';
import Typography from 'components/common/Typography';

import {
  CodeBlock,
  DATA_EXAMPLE,
  ScrollableArea,
} from '../DataStreamScreen.style';

const { Text, Title } = Typography;

const DataStreamSetupFAQModalContent = ({
  closeModal,
}: {
  closeModal: () => void;
}) => {
  const { t } = useTranslation();

  const faqItems = [
    {
      question: t('privacy.dataStream.faq.what_is_webhook.question'),
      answer: t('privacy.dataStream.faq.what_is_webhook.answer'),
    },
    {
      question: t('privacy.dataStream.faq.tls_support.question'),
      answer: t('privacy.dataStream.faq.tls_support.answer'),
    },
    {
      question: t('privacy.dataStream.faq.data_format.question'),
      answer: <CodeBlock>{DATA_EXAMPLE}</CodeBlock>,
    },
    {
      question: t('privacy.dataStream.faq.custom_headers.question'),
      answer: t('privacy.dataStream.faq.custom_headers.answer'),
    },
    {
      question: t('privacy.dataStream.faq.critical_alerts.question'),
      answer: t('privacy.dataStream.faq.critical_alerts.answer'),
    },
    {
      question: t('privacy.dataStream.faq.webhook_failures.question'),
      answer: t('privacy.dataStream.faq.webhook_failures.answer'),
    },
    {
      question: t('privacy.dataStream.faq.account_closure.question'),
      answer: t('privacy.dataStream.faq.account_closure.answer'),
    },
    {
      question: t('privacy.dataStream.faq.sensitive_data.question'),
      answer: t('privacy.dataStream.faq.sensitive_data.answer'),
    },
  ];

  return (
    <>
      <ModalHeader
        title={t('privacy.dataStream.setup.faq')}
        closeModal={closeModal}
      />

      <ScrollableArea>
        {faqItems.map(({ question, answer }) => (
          <Flex
            data-test='data-stream-setup-faq-entry'
            key={`faqItem-${question}`}
            flexDirection='column'
            paddingBottom='32px'>
            <Title level={3}>{question}</Title>
            <Text>{answer}</Text>
          </Flex>
        ))}
      </ScrollableArea>

      <Flex justifyContent='end' paddingTop='large'>
        <Button onClick={closeModal}>{t('common.close')}</Button>
      </Flex>
    </>
  );
};

export default DataStreamSetupFAQModalContent;
